// import { Bot, IBot } from "../bot";
import { IAddress } from "../user/address";
import { ICustomer, ICustomerData } from "./customer.types";
export class Customer implements ICustomer {
    readonly id?: string;
    name?: string;
    basketID?: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    email?: string | undefined;
    address: IAddress[];
    phone_number?: string | undefined;
    saleID?: string | undefined;

    constructor(data: any) {
        console.log({data});
        if (data.id) {
            this.id = data.id;
        }

        if (data.name) {
            this.name = data.name;
        }

        this.basketID = data.basketID;
        this.firstname = data.firstname;
        this.lastname = data.lastname;
        this.email = data.email;
        this.phone_number = data.phone_number;
        this.address = [];
        if(data.address){
            if(data.address.items){
                this.address = data.address.items;
            }
        }
        this.saleID = data.saleID;
    }

    validate(): boolean {
        if ([null, undefined, ""].indexOf(this.id) >= 0) {
            return false;
        }
        return true;
    }

    data(): ICustomerData {
        return Object.assign({}, this);
    }
}
